export default __webpack_public_path__ + "static/media/Anhållan-om-ledighet-rev-24.181905f9.pdf";